/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export const CartControllerAddResponseErrorTypeEnum = {
    NoPrescriptiontypes: 'NO_PRESCRIPTIONTYPES',
    NotAllowedPrescriptiontypes: 'NOT_ALLOWED_PRESCRIPTIONTYPES',
    NoOfferId: 'NO_OFFER_ID',
    NoQuantityProvided: 'NO_QUANTITY_PROVIDED',
    NoValidQuantityProvided: 'NO_VALID_QUANTITY_PROVIDED',
    InvalidQuantity: 'INVALID_QUANTITY',
    InvalidOfferId: 'INVALID_OFFER_ID',
    PutMpEntryToErxCardWithErx: 'PUT_MP_ENTRY_TO_ERX_CARD_WITH_ERX',
    PutMpEntryToCartWithOds: 'PUT_MP_ENTRY_TO_CART_WITH_ODS',
    PutRxEntryToCartWithErx: 'PUT_RX_ENTRY_TO_CART_WITH_ERX'
};
